/**
 * Make/Model/Year Finder - Interactive UI for vehicle search
 * Uses custom dropdowns matching Car Kits Finder style
 */

console.log('🚗 Make/Model/Year Finder: Script loaded successfully!');

const LUNA_API_BASE = 'https://luna-paint-api-298547824318.us-central1.run.app';

// Session cache for API responses
const API_CACHE = {
  brands: null,
  models: {}, // Key by brand name
  years: {},  // Key by modelId
};

// Initialize all finders on the page
document.addEventListener('DOMContentLoaded', function() {
  console.log('🚗 Make/Model/Year Finder: Initializing...');
  const finders = document.querySelectorAll('.make-model-year-finder');
  console.log('🚗 Make/Model/Year Finder: Found', finders.length, 'finders');
  
  finders.forEach((finder, index) => {
    console.log('🚗 Make/Model/Year Finder: Initializing finder', index + 1);
    initFinder(finder);
  });
});

/**
 * Initialize a single finder
 */
function initFinder(container) {
  console.log('🚗 Initializing finder on:', container);
  
  const endpoint = container.dataset.endpoint;
  const drawerId = container.dataset.drawerId;
  
  // Get dropdown elements
  const makeDropdown = container.querySelector('.make-dropdown');
  const modelDropdown = container.querySelector('.model-dropdown');
  const yearDropdown = container.querySelector('.year-dropdown');
  const searchBtn = container.querySelector('.finder-search-btn');
  
  // State management
  const state = {
    make: null,
    model: null,
    modelId: null,
    year: null,
    endpoint: endpoint,
    drawerId: drawerId,
    container: container,
    hasModels: true  // Track if models are available for selected make
  };
  
  // Setup custom dropdowns
  setupCustomDropdown(makeDropdown, state, 'make');
  setupCustomDropdown(modelDropdown, state, 'model');
  setupCustomDropdown(yearDropdown, state, 'year');
  
  // Setup keyboard navigation
  setupKeyboardNavigation(makeDropdown, state, 'make');
  setupKeyboardNavigation(modelDropdown, state, 'model');
  setupKeyboardNavigation(yearDropdown, state, 'year');
  
  // Setup search button
  searchBtn.addEventListener('click', () => onSearch(state, endpoint, drawerId));
  
  // Load initial data (brands)
  loadBrands(state, makeDropdown, modelDropdown, yearDropdown, searchBtn);
  
  // Render recent searches
  renderRecentSearches(state);
  
  // Setup text search mode toggle
  setupTextSearchToggle(state, container);
  
  console.log('🚗 Finder initialized successfully');
}

/**
 * Setup a custom dropdown with click handlers
 */
function setupCustomDropdown(dropdown, state, type) {
  const trigger = dropdown.querySelector('.kits-finder__dropdown-trigger');
  const options = dropdown.querySelector('.kits-finder__dropdown-options');
  
  // Move dropdown options to body on first click to escape overflow clipping
  let optionsMovedToBody = false;
  
  // Toggle dropdown
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Check if disabled or loading
    if (trigger.getAttribute('data-disabled') === 'true' || trigger.getAttribute('data-loading') === 'true') {
      if (trigger.getAttribute('data-disabled') === 'true') {
        showTooltip(trigger, 'Select previous option first');
      }
      return;
    }
    
    const isOpen = dropdown.classList.contains('open');
    
    // Close all other dropdowns (but don't unlock body yet - we'll handle that below)
    document.querySelectorAll('.kits-finder__dropdown.open').forEach(otherDropdown => {
      if (otherDropdown !== dropdown) {
        otherDropdown.classList.remove('open');
        // Also close their options if moved to body
        const otherOptions = otherDropdown.querySelector('.kits-finder__dropdown-options');
        if (otherOptions && otherOptions.parentElement === document.body) {
          otherOptions.classList.remove('open');
        }
      }
    });
    
    // Toggle current dropdown
    dropdown.classList.toggle('open', !isOpen);
    
    // Move options to body and position it if opening
    if (!isOpen) {
      if (!optionsMovedToBody) {
        document.body.appendChild(options);
        // Mark this as a make-model-year dropdown for styling
        options.setAttribute('data-finder-type', 'make-model-year');
        // Store reference to parent dropdown for later lookup
        options._parentDropdown = dropdown;
        optionsMovedToBody = true;
        console.log('🚗 Moved dropdown options to body');
      }
      
      // Lock body scroll on BOTH mobile AND desktop BEFORE positioning (prevents jump and scroll)
      if (document.body.style.position !== 'fixed') {
        const scrollY = window.scrollY;
        document.body.dataset.scrollY = scrollY;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.top = `-${scrollY}px`;
      }
      
      // Position the options relative to the trigger
      // Use requestAnimationFrame to ensure layout is complete (iOS Safari fix)
      requestAnimationFrame(() => {
        const rect = trigger.getBoundingClientRect();
        options.style.position = 'fixed';
        // Position exactly at bottom edge (trigger bottom border is transparent when open)
        options.style.top = rect.bottom + 'px';
        options.style.left = rect.left + 'px';
        // Set width with !important priority via cssText to ensure it matches trigger exactly
        options.style.setProperty('width', rect.width + 'px', 'important');
        console.log('🚗 Positioned dropdown:', { top: rect.bottom, left: rect.left, width: rect.width });
      });
      
      // Add open class to options since it's no longer a child of dropdown
      options.classList.add('open');
    } else {
      // Remove open class when closing
      options.classList.remove('open');
      
      // Unlock body scroll when closing (only if no other dropdowns are open)
      const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
      if (!hasOpenDropdowns && document.body.style.position === 'fixed') {
        const scrollY = document.body.dataset.scrollY;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY));
          delete document.body.dataset.scrollY;
        }
      }
    }
  });
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!dropdown.contains(e.target) && !options.contains(e.target)) {
      const wasOpen = dropdown.classList.contains('open');
      dropdown.classList.remove('open');
      options.classList.remove('open');
      
      // Unlock body scroll when closing (only if no other dropdowns are open)
      if (wasOpen) {
        const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
        if (!hasOpenDropdowns && document.body.style.position === 'fixed') {
          const scrollY = document.body.dataset.scrollY;
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.width = '';
          document.body.style.top = '';
          if (scrollY) {
            window.scrollTo(0, parseInt(scrollY));
            delete document.body.dataset.scrollY;
          }
        }
      }
    }
  });
  
  // Reposition dropdown on resize and orientation change only (body is locked, no scroll)
  let repositionFrame = null;
  
  function repositionDropdown() {
    // Only reposition on actual device rotation, not keyboard appearance
    if (dropdown.classList.contains('open') && options.parentElement === document.body) {
      // Cancel any pending frame to avoid stacking
      if (repositionFrame) {
        cancelAnimationFrame(repositionFrame);
      }
      
      repositionFrame = requestAnimationFrame(() => {
        const rect = trigger.getBoundingClientRect();
        
        // Position exactly at bottom edge (trigger bottom border is transparent when open)
        options.style.top = rect.bottom + 'px';
        options.style.left = rect.left + 'px';
        // Set width with !important priority to ensure it matches trigger exactly
        options.style.setProperty('width', rect.width + 'px', 'important');
        
        repositionFrame = null;
      });
    }
  }
  
  // Only reposition on orientation change (not resize which triggers on keyboard)
  window.addEventListener('orientationchange', repositionDropdown, { passive: true });
}

// Global ESC key listener to close ALL make-model-year dropdowns
// This runs once globally, not per-instance
let globalEscListener = null;
if (!globalEscListener) {
  globalEscListener = function(e) {
    if (e.key === 'Escape') {
      const openDropdowns = document.querySelectorAll('.make-model-year-finder .kits-finder__dropdown.open');
      if (openDropdowns.length > 0) {
        e.preventDefault();
        openDropdowns.forEach(dropdown => {
          dropdown.classList.remove('open');
          // Find and close associated options (might be in body)
          const allBodyOptions = document.querySelectorAll('body > .kits-finder__dropdown-options[data-finder-type="make-model-year"]');
          allBodyOptions.forEach(opt => {
            if (opt._parentDropdown === dropdown) {
              opt.classList.remove('open');
            }
          });
        });
        
        // Unlock body scroll when closing
        const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
        if (!hasOpenDropdowns && document.body.style.position === 'fixed') {
          const scrollY = document.body.dataset.scrollY;
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.width = '';
          document.body.style.top = '';
          if (scrollY) {
            window.scrollTo(0, parseInt(scrollY));
            delete document.body.dataset.scrollY;
          }
        }
      }
    }
  };
  document.addEventListener('keydown', globalEscListener);
}

/**
 * Setup keyboard navigation for dropdown
 */
function setupKeyboardNavigation(dropdown, state, type) {
  const trigger = dropdown.querySelector('.kits-finder__dropdown-trigger');
  const options = dropdown.querySelector('.kits-finder__dropdown-options');
  
  let selectedIndex = -1;
  
  // Enter or Space on trigger opens dropdown
  trigger.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (trigger.getAttribute('data-disabled') !== 'true' && trigger.getAttribute('data-loading') !== 'true') {
        trigger.click();
      }
    }
  });
  
  // Arrow keys, Enter, Escape navigation in options
  document.addEventListener('keydown', function(e) {
    if (!dropdown.classList.contains('open')) {
      selectedIndex = -1;
      return;
    }
    
    const allOptions = Array.from(options.querySelectorAll('.kits-finder__dropdown-option:not([style*="display: none"])'));
    
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      selectedIndex = Math.min(selectedIndex + 1, allOptions.length - 1);
      highlightOption(allOptions, selectedIndex);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      selectedIndex = Math.max(selectedIndex - 1, 0);
      highlightOption(allOptions, selectedIndex);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (selectedIndex >= 0 && allOptions[selectedIndex]) {
        allOptions[selectedIndex].click();
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      dropdown.classList.remove('open');
      options.classList.remove('open');
      selectedIndex = -1;
      
      // Unlock body scroll when closing (only if no other dropdowns are open)
      const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
      if (!hasOpenDropdowns && document.body.style.position === 'fixed') {
        const scrollY = document.body.dataset.scrollY;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY));
          delete document.body.dataset.scrollY;
        }
      }
    }
  });
}

/**
 * Highlight option during keyboard navigation
 */
function highlightOption(options, index) {
  options.forEach((opt, i) => {
    opt.classList.toggle('keyboard-highlighted', i === index);
  });
  if (options[index]) {
    options[index].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
}

/**
 * Show tooltip for disabled dropdown
 */
function showTooltip(trigger, message) {
  let tooltip = document.querySelector('.kits-finder__disabled-tooltip');
  
  if (!tooltip) {
    tooltip = document.createElement('div');
    tooltip.className = 'kits-finder__disabled-tooltip';
    document.body.appendChild(tooltip);
  }
  
  tooltip.textContent = message;
  
  const rect = trigger.getBoundingClientRect();
  tooltip.style.left = rect.left + (rect.width / 2) + 'px';
  tooltip.style.top = rect.top - 8 + 'px';
  
  tooltip.offsetHeight; // Force reflow
  tooltip.classList.add('show');
  
  setTimeout(() => {
    tooltip.classList.remove('show');
  }, 2000);
}

/**
 * Populate dropdown options
 */
function populateDropdownOptions(dropdown, items, state, type) {
  console.log('🚗 populateDropdownOptions called:', { type, itemCount: items.length });
  
  // First try to find options in dropdown, then check if it's been moved to body
  let optionsContainer = dropdown.querySelector('.kits-finder__dropdown-options');
  
  // If not found in dropdown, it might have been moved to body - search by stored reference
  if (!optionsContainer) {
    const allBodyOptions = document.querySelectorAll('body > .kits-finder__dropdown-options[data-finder-type="make-model-year"]');
    
    // Find which one belongs to this dropdown by checking stored parent reference
    for (const option of allBodyOptions) {
      if (option._parentDropdown === dropdown) {
        optionsContainer = option;
        console.log('🚗 Found options container in body for this dropdown');
        break;
      }
    }
  }
  
  const trigger = dropdown.querySelector('.kits-finder__dropdown-trigger');
  const triggerText = trigger ? trigger.querySelector('.kits-finder__dropdown-text') : null;
  
  console.log('🚗 Dropdown elements:', {
    hasOptionsContainer: !!optionsContainer,
    hasTrigger: !!trigger,
    hasTriggerText: !!triggerText
  });
  
  if (!optionsContainer || !trigger || !triggerText) {
    console.error('🚗 Missing dropdown elements!');
    return;
  }
  
  // Clear existing options
  optionsContainer.innerHTML = '';
  
  // Add search input at top of dropdown
  const searchInput = document.createElement('input');
  searchInput.type = 'text';
  searchInput.className = 'kits-finder__dropdown-search';
  searchInput.placeholder = `Search ${type}...`;
  searchInput.addEventListener('click', e => e.stopPropagation());
  searchInput.addEventListener('input', e => {
    filterDropdownOptions(e.target.value, optionsContainer);
    
    // Track dropdown search usage
    if (e.target.value.length >= 2 && window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder',
        action: 'dropdown_search_used',
        label: type,
        metadata: { query: e.target.value }
      });
    }
  });
  optionsContainer.appendChild(searchInput);
  
  // Setup scroll detection for search input visibility
  setupDropdownScrollBehavior(optionsContainer, searchInput);
  
  // Add options
  items.forEach((item, index) => {
    console.log(`🚗 Creating option ${index + 1}:`, item.label);
    const option = document.createElement('div');
    option.className = 'kits-finder__dropdown-option';
    option.dataset.value = item.value;
    if (item.id) option.dataset.id = item.id;
    
    const text = document.createElement('span');
    text.className = 'dropdown-option-text';
    text.textContent = item.label;
    option.appendChild(text);
    
    // Click handler
    option.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('🚗 Option clicked:', { type, label: item.label, value: item.value, id: item.id });
      
      // Update trigger text
      triggerText.textContent = item.label;
      
      // Update selected state
      optionsContainer.querySelectorAll('.kits-finder__dropdown-option').forEach(opt => {
        opt.classList.remove('selected');
      });
      option.classList.add('selected');
      
      // Close dropdown
      dropdown.classList.remove('open');
      optionsContainer.classList.remove('open');
      
      // Unlock body scroll when closing (only if no other dropdowns are open)
      const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
      if (!hasOpenDropdowns && document.body.style.position === 'fixed') {
        const scrollY = document.body.dataset.scrollY;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY));
          delete document.body.dataset.scrollY;
        }
      }
      
      // Update state and trigger cascade
      if (type === 'make') {
        state.make = item.value;
        state.model = null;
        state.modelId = null;
        state.year = null;
        state.hasModels = true;  // Reset to true, will be set to false if no models found
        console.log('🚗 Make selected:', state.make, '(from item.value:', item.value, ')');
        
        // Reset search button text
        const searchBtn = state.container.querySelector('.finder-search-btn');
        const btnText = searchBtn.querySelector('.finder-btn-text');
        btnText.textContent = 'Search';
        searchBtn.disabled = true;
        searchBtn.style.opacity = '0.5';
        searchBtn.style.pointerEvents = 'none';
        
        // Reset model and year dropdown texts and clear options
        const modelDropdown = state.container.querySelector('.model-dropdown');
        const yearDropdown = state.container.querySelector('.year-dropdown');
        const modelTrigger = modelDropdown.querySelector('.kits-finder__dropdown-trigger');
        const yearTrigger = yearDropdown.querySelector('.kits-finder__dropdown-trigger');
        modelTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Model...';
        yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
        
        // Clear model dropdown options (whether in dropdown or body)
        let modelOptionsContainer = modelDropdown.querySelector('.kits-finder__dropdown-options');
        if (!modelOptionsContainer) {
          const allBodyOptions = document.querySelectorAll('body > .kits-finder__dropdown-options[data-finder-type="make-model-year"]');
          for (const option of allBodyOptions) {
            if (option._parentDropdown === modelDropdown) {
              modelOptionsContainer = option;
              break;
            }
          }
        }
        if (modelOptionsContainer) {
          modelOptionsContainer.innerHTML = '';
        }
        
        // Clear year dropdown options (whether in dropdown or body)
        let yearOptionsContainer = yearDropdown.querySelector('.kits-finder__dropdown-options');
        if (!yearOptionsContainer) {
          const allBodyOptions = document.querySelectorAll('body > .kits-finder__dropdown-options[data-finder-type="make-model-year"]');
          for (const option of allBodyOptions) {
            if (option._parentDropdown === yearDropdown) {
              yearOptionsContainer = option;
              break;
            }
          }
        }
        if (yearOptionsContainer) {
          yearOptionsContainer.innerHTML = '';
        }
        
        // Track analytics
        if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
          window.DYCAnalytics.track('custom', {
            category: 'make_model_year_finder',
            action: 'make_selected',
            label: item.value
          });
        }
        
        // Load models for this make
        const finderContainer = state.container.querySelector('.finder-container');
        finderContainer.classList.remove('make-only-mode');
        loadModels(state, item.value, modelDropdown, yearDropdown, searchBtn);
        
      } else if (type === 'model') {
        state.model = item.value;
        state.modelId = item.id;
        state.year = null;
        console.log('🚗 Model selected:', item.value, 'ID:', item.id);
        
        // Reset search button text
        const searchBtn = state.container.querySelector('.finder-search-btn');
        const btnText = searchBtn.querySelector('.finder-btn-text');
        btnText.textContent = 'Search';
        searchBtn.disabled = true;
        searchBtn.style.opacity = '0.5';
        searchBtn.style.pointerEvents = 'none';
        
        // Reset year dropdown text and clear options
        const yearDropdown = state.container.querySelector('.year-dropdown');
        const yearTrigger = yearDropdown.querySelector('.kits-finder__dropdown-trigger');
        yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
        yearTrigger.setAttribute('data-disabled', 'true');
        
        // Clear year dropdown options (whether in dropdown or body)
        let yearOptionsContainer = yearDropdown.querySelector('.kits-finder__dropdown-options');
        if (!yearOptionsContainer) {
          const allBodyOptions = document.querySelectorAll('body > .kits-finder__dropdown-options[data-finder-type="make-model-year"]');
          for (const option of allBodyOptions) {
            if (option._parentDropdown === yearDropdown) {
              yearOptionsContainer = option;
              break;
            }
          }
        }
        if (yearOptionsContainer) {
          yearOptionsContainer.innerHTML = '';
        }
        
        // Track analytics
        if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
          window.DYCAnalytics.track('custom', {
            category: 'make_model_year_finder',
            action: 'model_selected',
            label: `${state.make} - ${item.value}`
          });
        }
        
        // Load years for this model
        loadYears(state, item.id, yearDropdown, searchBtn);
        
      } else if (type === 'year') {
        state.year = item.value;
        console.log('🚗 Year selected:', item.value);
        
        // Track analytics
        if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
          window.DYCAnalytics.track('custom', {
            category: 'make_model_year_finder',
            action: 'year_selected',
            label: `${state.make} ${state.model} ${item.value}`
          });
        }
        
        // Enable search button
        const searchBtn = state.container.querySelector('.finder-search-btn');
        updateSearchButton(state, searchBtn);
      }
    });
    
    optionsContainer.appendChild(option);
  });
  
  // Remove loading state
  trigger.removeAttribute('data-loading');
  
  console.log('🚗 Populated', items.length, type, 'options');
  console.log('🚗 Options container children count:', optionsContainer.children.length);
  console.log('🚗 First option HTML:', optionsContainer.children[0]?.outerHTML);
}

/**
 * Filter dropdown options based on search query
 */
function filterDropdownOptions(query, container) {
  const options = container.querySelectorAll('.kits-finder__dropdown-option');
  const lowerQuery = query.toLowerCase();
  
  options.forEach(opt => {
    const text = opt.textContent.toLowerCase();
    opt.style.display = text.includes(lowerQuery) ? 'flex' : 'none';
  });
}

/**
 * Setup scroll behavior for dropdown search input
 */
function setupDropdownScrollBehavior(optionsContainer, searchInput) {
  let lastScrollTop = 0;
  
  optionsContainer.addEventListener('scroll', function() {
    const scrollTop = optionsContainer.scrollTop;
    
    if (scrollTop > lastScrollTop && scrollTop > 50) {
      // Scrolling DOWN - hide search input
      searchInput.classList.add('hidden-on-scroll');
    } else if (scrollTop < lastScrollTop) {
      // Scrolling UP - show search input
      searchInput.classList.remove('hidden-on-scroll');
    }
    
    // If at the very top, always show
    if (scrollTop <= 10) {
      searchInput.classList.remove('hidden-on-scroll');
    }
    
    lastScrollTop = scrollTop;
  });
}

/**
 * Setup text search mode toggle
 */
function setupTextSearchToggle(state, container) {
  const toggleBtn = container.querySelector('.finder-mode-toggle');
  const toggleBackBtn = container.querySelector('.finder-mode-toggle-back');
  const finderContainer = container.querySelector('.finder-container');
  const textSearchContainer = container.querySelector('.finder-text-search-container');
  const textSearchInput = container.querySelector('.finder-text-search-input');
  const textSearchBtn = container.querySelector('.finder-text-search-btn');
  const bottomRow = container.querySelector('.finder-bottom-row');
  
  // Find the subtext elements (both desktop and mobile)
  const slide = container.closest('.slider-slide');
  const subtextElements = slide ? slide.querySelectorAll('.finder-subtext') : [];
  
  // Set initial state: hide subtext if no dropdown text
  subtextElements.forEach(el => {
    const dropdownText = el.getAttribute('data-dropdown-text');
    if (!dropdownText) {
      el.style.display = 'none';
    }
  });
  
  if (!toggleBtn || !textSearchContainer) return;
  
  // Toggle to text search mode
  toggleBtn.addEventListener('click', () => {
    // Update subtext to text search mode
    subtextElements.forEach(el => {
      const textSearchText = el.getAttribute('data-text-search-text');
      if (textSearchText) {
        el.innerHTML = textSearchText;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
    
    // Animate transition
    finderContainer.classList.add('hidden-mode');
    if (bottomRow) {
      bottomRow.style.opacity = '0';
      bottomRow.style.transition = 'opacity 0.2s ease';
    }
    
    // Show text search after dropdown animation
    setTimeout(() => {
      if (bottomRow) {
        bottomRow.style.display = 'none';
      }
      textSearchContainer.style.display = 'flex';
      textSearchContainer.style.flexDirection = 'column';
      textSearchContainer.style.alignItems = 'center';
      requestAnimationFrame(() => {
        textSearchContainer.classList.add('active');
      });
    }, 150);
    
    // Track mode switch
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder',
        action: 'mode_switched',
        label: 'text_search'
      });
    }
  });
  
  // Toggle back to dropdown mode
  toggleBackBtn.addEventListener('click', () => {
    // Update subtext back to dropdown mode
    subtextElements.forEach(el => {
      const dropdownText = el.getAttribute('data-dropdown-text');
      if (dropdownText) {
        el.innerHTML = dropdownText;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
    
    textSearchContainer.classList.remove('active');
    
    setTimeout(() => {
      textSearchContainer.style.display = 'none';
      finderContainer.classList.remove('hidden-mode');
      if (bottomRow) {
        bottomRow.style.display = 'flex';
        bottomRow.style.opacity = '0';
        requestAnimationFrame(() => {
          bottomRow.style.transition = 'opacity 0.3s ease';
          bottomRow.style.opacity = '1';
        });
      }
    }, 150);
    
    // Track mode switch
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder',
        action: 'mode_switched',
        label: 'dropdown'
      });
    }
  });
  
  // Handle text search
  const performTextSearch = () => {
    const query = textSearchInput.value.trim();
    if (!query) return;
    
    // Track text search
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder',
        action: 'text_search_executed',
        label: query
      });
    }
    
    // Open MCC iframe with text query (same as mcc-search-input)
    openMCCWithTextQuery(query);
  };
  
  textSearchBtn.addEventListener('click', performTextSearch);
  textSearchInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      performTextSearch();
    }
  });
}

/**
 * Open MCC app with text query (for text search mode)
 */
function openMCCWithTextQuery(query) {
  console.log('🚗 Opening MCC app with text query:', query);
  
  // Get or create the MCC iframe
  let iframe = document.getElementById('mcc-iframe');
  
  if (!iframe) {
    console.log('🚗 MCC iframe not found, creating one...');
    iframe = createMCCIframe();
  }
  
  // Show the iframe
  iframe.style.display = 'block';
  
  // Send message to MCC app with text query
  const message = {
    type: 'openModal',
    window: 'colorSearch',
    searchQuery: query
  };
  
  console.log('🚗 Sending text query to MCC app:', message);
  
  // Wait for iframe to be ready, then send message
  setTimeout(() => {
    if (iframe.contentWindow) {
      iframe.contentWindow.postMessage(message, '*');
      console.log('🚗 Text query sent to MCC app');
    }
  }, 100);
}

/**
 * Load brands from Luna Paint API
 */
async function loadBrands(state, makeDropdown, modelDropdown, yearDropdown, searchBtn) {
  const trigger = makeDropdown.querySelector('.kits-finder__dropdown-trigger');
  
  // Check cache first
  if (API_CACHE.brands) {
    console.log('🚗 Using cached brands');
    populateDropdownOptions(makeDropdown, API_CACHE.brands, state, 'make');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Make...';
    return;
  }
  
  console.log('🚗 Fetching brands from Luna Paint API...');
  trigger.setAttribute('data-loading', 'true');
  trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Loading...';
  
  try {
    const response = await fetch(`${LUNA_API_BASE}/brands`);
    const brands = await response.json();
    
    console.log('🚗 Brands loaded:', brands.length);
    console.log('🚗 First brand object:', brands[0]);
    
    const brandItems = brands.map(brand => {
      // Handle if brand is an object or a string
      const brandName = typeof brand === 'string' ? brand : (brand.brand || brand.name);
      
      return {
        value: brandName,
        label: brandName
      };
    });
    
    // Cache the results
    API_CACHE.brands = brandItems;
    
    populateDropdownOptions(makeDropdown, brandItems, state, 'make');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Make...';
    
    // Track analytics
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder',
        action: 'brands_loaded',
        label: brands.length.toString()
      });
    }
    
  } catch (error) {
    console.error('🚗 Error loading brands:', error);
    trigger.removeAttribute('data-loading');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Error loading makes';
  }
}

/**
 * Load models for a brand
 */
async function loadModels(state, brandName, modelDropdown, yearDropdown, searchBtn) {
  const trigger = modelDropdown.querySelector('.kits-finder__dropdown-trigger');
  const yearTrigger = yearDropdown.querySelector('.kits-finder__dropdown-trigger');
  const finderContainer = state.container.querySelector('.finder-container');
  
  // Check cache first
  if (API_CACHE.models[brandName]) {
    console.log('🚗 Using cached models for', brandName);
    const cachedModels = API_CACHE.models[brandName];
    
    if (cachedModels.length === 0) {
      // Handle cached empty result
      state.hasModels = false;
      trigger.removeAttribute('data-loading');
      trigger.setAttribute('data-disabled', 'true');
      trigger.querySelector('.kits-finder__dropdown-text').textContent = 'No models available';
      yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'No years available';
      finderContainer.classList.add('make-only-mode');
      updateSearchButton(state, searchBtn);
      return;
    }
    
    state.hasModels = true;
    finderContainer.classList.remove('make-only-mode');
    trigger.removeAttribute('data-disabled');
    populateDropdownOptions(modelDropdown, cachedModels, state, 'model');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Model...';
    yearTrigger.setAttribute('data-disabled', 'true');
    yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
    return;
  }
  
  console.log('🚗 Fetching models for brand:', brandName);
  
  // Set loading state
  trigger.setAttribute('data-loading', 'true');
  trigger.removeAttribute('data-disabled');
  trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Loading...';
  
  // Reset year dropdown
  yearTrigger.setAttribute('data-disabled', 'true');
  yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
  yearDropdown.querySelector('.kits-finder__dropdown-options').innerHTML = '';
  
  // Disable search button
  searchBtn.disabled = true;
  
  try {
    const response = await fetch(`${LUNA_API_BASE}/models/?brand=${encodeURIComponent(brandName)}`);
    const models = await response.json();
    
    console.log('🚗 Models loaded for', brandName, ':', models.length);
    console.log('🚗 First model object:', models[0]);
    
    // Check if no models available
    if (!models || models.length === 0) {
      console.log('🚗 No models available for', brandName, '- enabling search with just Make');
      state.hasModels = false;
      trigger.removeAttribute('data-loading');
      trigger.setAttribute('data-disabled', 'true');
      trigger.querySelector('.kits-finder__dropdown-text').textContent = 'No models available';
      
      // Also disable year dropdown
      yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'No years available';
      
      // Hide model and year dropdowns (make-only mode)
      finderContainer.classList.add('make-only-mode');
      
      // Cache empty result
      API_CACHE.models[brandName] = [];
      
      // Enable search button with just Make
      updateSearchButton(state, searchBtn);
      
      // Track analytics
      if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
        window.DYCAnalytics.track('custom', {
          category: 'make_model_year_finder',
          action: 'models_loaded',
          label: brandName,
          metadata: { count: 0, hasModels: false }
        });
      }
      
      return;
    }
    
    state.hasModels = true;
    finderContainer.classList.remove('make-only-mode');
    
    const modelItems = models.map(model => {
      // Handle if model is an object or a string
      const modelName = typeof model === 'string' ? model : (model.type || model.model || model.name);
      const modelId = typeof model === 'object' ? model.id : null;
      
      console.log('🚗 Mapping model:', { original: model, modelName, modelId });
      
      return {
        value: modelName,
        label: modelName,
        id: modelId
      };
    });
    
    // Cache the results
    API_CACHE.models[brandName] = modelItems;
    
    populateDropdownOptions(modelDropdown, modelItems, state, 'model');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Model...';
    
    // Track analytics
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder',
        action: 'models_loaded',
        label: brandName,
        metadata: { count: models.length, hasModels: true }
      });
    }
    
  } catch (error) {
    console.error('🚗 Error loading models:', error);
    trigger.removeAttribute('data-loading');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Error loading models';
  }
}

/**
 * Load years for a model
 */
async function loadYears(state, modelId, yearDropdown, searchBtn) {
  const trigger = yearDropdown.querySelector('.kits-finder__dropdown-trigger');
  
  // Check cache first
  if (API_CACHE.years[modelId]) {
    console.log('🚗 Using cached years for model ID:', modelId);
    populateDropdownOptions(yearDropdown, API_CACHE.years[modelId], state, 'year');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
    return;
  }
  
  console.log('🚗 Fetching years for model ID:', modelId);
  
  // Set loading state
  trigger.setAttribute('data-loading', 'true');
  trigger.removeAttribute('data-disabled');
  trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Loading...';
  
  // Disable search button
  searchBtn.disabled = true;
  
  try {
    const response = await fetch(`${LUNA_API_BASE}/years/?model_id=${modelId}`);
    const years = await response.json();
    
    console.log('🚗 Years loaded for model', state.model, ':', years.length);
    console.log('🚗 First year object:', years[0]);
    
    const yearItems = years.map(year => {
      // Handle if year is an object or a string/number
      const yearValue = typeof year === 'object' ? (year.year || year.value) : year;
      
      return {
        value: yearValue,
        label: String(yearValue)
      };
    });
    
    // Cache the results
    API_CACHE.years[modelId] = yearItems;
    
    populateDropdownOptions(yearDropdown, yearItems, state, 'year');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
    
  } catch (error) {
    console.error('🚗 Error loading years:', error);
    trigger.removeAttribute('data-loading');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Error loading years';
  }
}

/**
 * Update search button state
 */
function updateSearchButton(state, searchBtn) {
  // Allow search with just Make if no models available, otherwise require all fields
  const isReady = state.hasModels 
    ? (state.make && state.model && state.year)
    : state.make;
  
  const btnText = searchBtn.querySelector('.finder-btn-text');
  
  if (isReady) {
    searchBtn.disabled = false;
    searchBtn.style.opacity = '1';
    searchBtn.style.pointerEvents = 'auto';
    
    // Update button text to show what will be searched
    if (state.hasModels && state.model && state.year) {
      btnText.textContent = `Search ${state.make} ${state.model} ${state.year}`;
    } else if (state.make) {
      btnText.textContent = `Search ${state.make}`;
    }
    
    console.log('🚗 Search button enabled', state.hasModels ? '(all fields)' : '(make only)');
  } else {
    searchBtn.disabled = true;
    searchBtn.style.opacity = '0.5';
    searchBtn.style.pointerEvents = 'none';
    btnText.textContent = 'Search';
    
    console.log('🚗 Search button disabled - missing:', {
      make: state.make ? null : 'make',
      model: state.model ? null : 'model',
      year: state.year ? null : 'year',
      hasModels: state.hasModels
    });
  }
}

/**
 * Handle search button click
 */
async function onSearch(state, endpoint, drawerId) {
  console.log('🚗 onSearch called with state:', state);
  
  // Validate based on whether models are available
  if (!state.make) {
    console.error('🚗 Missing Make');
    return;
  }
  
  if (state.hasModels && (!state.model || !state.year || !state.modelId)) {
    console.error('🚗 Missing required fields (model/year)');
    return;
  }
  
  const searchBtn = state.container.querySelector('.finder-search-btn');
  const originalText = searchBtn.querySelector('.finder-btn-text').textContent;
  
  // Show loading state
  searchBtn.disabled = true;
  searchBtn.querySelector('.finder-btn-text').textContent = 'Searching...';
  
  console.log('🚗 Searching for colors:', {
    make: state.make,
    model: state.model || 'N/A',
    year: state.year || 'N/A',
    modelId: state.modelId || 'N/A',
    hasModels: state.hasModels
  });
  
  // Build search query for analytics
  const searchQuery = state.hasModels && state.model && state.year
    ? `${state.make} ${state.model} ${state.year}`
    : state.make;
  
  // Track analytics
  if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
    window.DYCAnalytics.track('custom', {
      category: 'make_model_year_finder',
      action: 'search_executed',
      label: searchQuery,
      metadata: { hasModels: state.hasModels }
    });
  }
  
  // Save to recent searches
  saveRecentSearch(state);
  
  // If no models available, skip API call and open MCC directly with just Make
  if (!state.hasModels) {
    console.log('🚗 No models available - opening MCC with Make only');
    openMCCWithSearch(state);
    searchBtn.disabled = false;
    searchBtn.querySelector('.finder-btn-text').textContent = originalText;
    return;
  }
  
  console.log('🚗 Calling search endpoint:', endpoint);
  
  try {
    const customResponse = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        model_id: state.modelId,
        year: state.year
      })
    });

    const response = await customResponse.json();
    console.log('🚗 Search response:', response);

    if (response.status === 'success') {
      console.log('🚗 Search successful:', response.colors?.length || 0, 'colors');

      // Open MCC iframe directly with search query
      if (response.colors && response.colors.length > 0) {
        openMCCWithSearch(state);
      } else {
        alert('No colors found for this vehicle');
      }
    } else {
      console.error('🚗 Search failed:', response);
      alert('Search failed: ' + (response.message || 'Unknown error'));
    }
  } catch (error) {
    console.error('🚗 Search error:', error);
    alert('Search error: ' + (error instanceof Error ? error.message : 'Unknown error'));
  } finally {
    searchBtn.disabled = false;
    searchBtn.querySelector('.finder-btn-text').textContent = originalText;
  }
}

/**
 * Open MCC app with search query
 */
function openMCCWithSearch(state) {
  console.log('🚗 Opening MCC app with search query');
  
  // Get or create the MCC iframe
  let iframe = document.getElementById('mcc-iframe');
  
  if (!iframe) {
    console.log('🚗 MCC iframe not found, creating one...');
    iframe = createMCCIframe();
  }
  
  // Build search query from state - use available fields
  let searchQuery;
  if (state.hasModels && state.model && state.year) {
    // Full query: Make Model Year
    searchQuery = `${state.make} ${state.model} ${state.year}`;
  } else {
    // Just Make (when no models available)
    searchQuery = state.make;
  }
  console.log('🚗 Search query:', searchQuery);
  
  // Show the iframe
  iframe.style.display = 'block';
  
  // Check if we're in product-view mode (for OEM landing page)
  const mode = state.container?.dataset.mode || 'shop';
  console.log('🚗 MCC Mode:', mode);
  
  // Send message to MCC app
  const message = {
    type: 'openModal',
    window: 'colorSearch',
    searchQuery: searchQuery,
    mode: mode  // Pass mode to MCC app
  };
  
  console.log('🚗 Sending message to MCC app:', message);
  
  // Wait for iframe to be ready, then send message
  setTimeout(() => {
    if (iframe.contentWindow) {
      iframe.contentWindow.postMessage(message, '*');
      console.log('🚗 Message sent to MCC app');
    }
  }, 100);
}

/**
 * Recent searches management
 */
function saveRecentSearch(state) {
  const searches = getRecentSearches();
  const newSearch = {
    make: state.make,
    model: state.model || null,
    year: state.year || null,
    timestamp: Date.now()
  };
  
  // Remove duplicates, add to front
  const filtered = searches.filter(s => 
    !(s.make === newSearch.make && s.model === newSearch.model && s.year === newSearch.year)
  );
  filtered.unshift(newSearch);
  
  // Keep last 5
  localStorage.setItem('mmyf_recent', JSON.stringify(filtered.slice(0, 5)));
  renderRecentSearches(state);
}

function getRecentSearches() {
  try {
    return JSON.parse(localStorage.getItem('mmyf_recent') || '[]');
  } catch {
    return [];
  }
}

function renderRecentSearches(state) {
  const container = state.container.querySelector('.recent-searches-container');
  const toggleBtn = state.container.querySelector('.recent-searches-toggle-btn');
  const dropdown = state.container.querySelector('.recent-searches-dropdown');
  
  if (!container) return;
  
  const searches = getRecentSearches();
  
  if (searches.length === 0) {
    container.style.display = 'none';
    if (toggleBtn) toggleBtn.style.display = 'none';
    if (dropdown) dropdown.style.display = 'none';
    return;
  }
  
  // Check if mobile (width <= 749px)
  const isMobile = window.innerWidth <= 749;
  
  // On mobile: always use dropdown if any searches exist (keeps buttons aligned on one line)
  // On desktop: use dropdown if 2+ searches
  const shouldCollapse = isMobile ? searches.length >= 1 : searches.length >= 2;
  
  if (shouldCollapse) {
    // Show toggle button with dropdown, hide inline container
    // (Mobile: 1+ searches, Desktop: 2+ searches)
    container.style.display = 'none';
    if (toggleBtn) {
      toggleBtn.style.display = 'inline-flex';
      const toggleText = toggleBtn.querySelector('.recent-toggle-text');
      if (toggleText) {
        toggleText.textContent = `Recent (${searches.length})`;
      }
    }
    
    // Populate dropdown
    if (dropdown) {
      dropdown.style.display = 'block';
      dropdown.innerHTML = '<div class="recent-searches-dropdown-content">' +
        searches.map((s, index) => {
          const label = s.model && s.year ? `${s.make} ${s.model} ${s.year}` : s.make;
          return `<button class="recent-search-chip" data-index="${index}">${label}</button>`;
        }).join('') +
        '</div>';
      
      // Add click handlers for dropdown chips
      dropdown.querySelectorAll('.recent-search-chip').forEach((chip, index) => {
        chip.addEventListener('click', () => {
          const search = searches[index];
          applyRecentSearch(state, search);
          
          // Close dropdown
          dropdown.classList.remove('open');
          if (toggleBtn) toggleBtn.classList.remove('open');
          
          // Track analytics
          if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
            window.DYCAnalytics.track('custom', {
              category: 'make_model_year_finder',
              action: 'recent_search_clicked',
              label: chip.textContent
            });
          }
        });
      });
    }
  } else {
    // Desktop with 0-1 searches: Show inline, hide toggle
    // (Mobile never reaches here with searches.length > 0)
    if (toggleBtn) toggleBtn.style.display = 'none';
    if (dropdown) {
      dropdown.style.display = 'none';
      dropdown.classList.remove('open');
    }
    
    container.style.display = 'flex';
    container.innerHTML = '<div class="recent-searches-label">Recent:</div>' +
      searches.map((s, index) => {
        const label = s.model && s.year ? `${s.make} ${s.model} ${s.year}` : s.make;
        return `<button class="recent-search-chip" data-index="${index}">${label}</button>`;
      }).join('');
    
      // Add click handlers for inline chips
    container.querySelectorAll('.recent-search-chip').forEach((chip, index) => {
      chip.addEventListener('click', () => {
        const search = searches[index];
        applyRecentSearch(state, search);
        
        // Track analytics
        if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
          window.DYCAnalytics.track('custom', {
            category: 'make_model_year_finder',
            action: 'recent_search_clicked',
            label: chip.textContent
          });
        }
      });
    });
  }
  
  // Setup toggle button click handler (only once)
  if (toggleBtn && !toggleBtn.dataset.initialized) {
    toggleBtn.dataset.initialized = 'true';
    
    // Move dropdown to body on first initialization (like main dropdowns)
    if (dropdown && dropdown.parentElement !== document.body) {
      document.body.appendChild(dropdown);
      dropdown.setAttribute('data-finder-type', 'recent-searches');
      console.log('🚗 Moved recent searches dropdown to body');
    }
    
    toggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      
      const isOpen = toggleBtn.classList.contains('open');
      toggleBtn.classList.toggle('open');
      
      if (dropdown) {
        dropdown.classList.toggle('open');
        
        // Position the dropdown relative to the toggle button
        if (!isOpen) {
          requestAnimationFrame(() => {
            const rect = toggleBtn.getBoundingClientRect();
            dropdown.style.position = 'fixed';
            dropdown.style.top = `${rect.bottom + 8}px`;
            dropdown.style.left = `${rect.left}px`;
            dropdown.style.right = 'auto';
            console.log('🚗 Positioned recent searches dropdown:', { top: rect.bottom + 8, left: rect.left });
          });
        }
      }
      
      // Track analytics
      if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
        window.DYCAnalytics.track('custom', {
          category: 'make_model_year_finder',
          action: 'recent_dropdown_toggled',
          label: dropdown?.classList.contains('open') ? 'opened' : 'closed'
        });
      }
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (toggleBtn && dropdown && !toggleBtn.contains(e.target) && !dropdown.contains(e.target)) {
        toggleBtn.classList.remove('open');
        dropdown.classList.remove('open');
      }
    });
    
    // Close dropdown immediately on scroll
    window.addEventListener('scroll', () => {
      if (dropdown && dropdown.classList.contains('open')) {
        toggleBtn.classList.remove('open');
        dropdown.classList.remove('open');
      }
    }, { passive: true });
    
    // Reposition on window resize
    window.addEventListener('resize', () => {
      if (dropdown && dropdown.classList.contains('open')) {
        requestAnimationFrame(() => {
          const rect = toggleBtn.getBoundingClientRect();
          dropdown.style.top = `${rect.bottom + 8}px`;
          dropdown.style.left = `${rect.left}px`;
        });
      }
    });
  }
  
  // Re-render on window resize to handle mobile/desktop switch
  const handleResize = () => renderRecentSearches(state);
  window.removeEventListener('resize', handleResize);
  window.addEventListener('resize', handleResize);
}

async function applyRecentSearch(state, search) {
  console.log('🚗 Applying recent search:', search);
  
  const makeDropdown = state.container.querySelector('.make-dropdown');
  const modelDropdown = state.container.querySelector('.model-dropdown');
  const yearDropdown = state.container.querySelector('.year-dropdown');
  const searchBtn = state.container.querySelector('.finder-search-btn');
  
  // Set make
  state.make = search.make;
  state.model = null;
  state.modelId = null;
  state.year = null;
  state.hasModels = true;
  
  // Update make dropdown text
  const makeTrigger = makeDropdown.querySelector('.kits-finder__dropdown-trigger');
  makeTrigger.querySelector('.kits-finder__dropdown-text').textContent = search.make;
  
  // Load models
  await loadModels(state, search.make, modelDropdown, yearDropdown, searchBtn);
  
  // If recent search has model/year, set them
  if (search.model && state.hasModels) {
    state.model = search.model;
    const modelTrigger = modelDropdown.querySelector('.kits-finder__dropdown-trigger');
    modelTrigger.querySelector('.kits-finder__dropdown-text').textContent = search.model;
    
    // Find modelId from cached models
    const cachedModels = API_CACHE.models[search.make];
    if (cachedModels) {
      const modelItem = cachedModels.find(m => m.value === search.model);
      if (modelItem) {
        state.modelId = modelItem.id;
        
        // Load years
        await loadYears(state, modelItem.id, yearDropdown, searchBtn);
        
        // Set year if available
        if (search.year) {
          state.year = search.year;
          const yearTrigger = yearDropdown.querySelector('.kits-finder__dropdown-trigger');
          yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = search.year;
        }
      }
    }
  }
  
  // Update search button
  updateSearchButton(state, searchBtn);
  
  // Automatically execute the search
  console.log('🚗 Auto-executing search from recent selection');
  await onSearch(state, state.endpoint, state.drawerId);
}

/**
 * Create MCC iframe (matching mcc.js implementation)
 */
function createMCCIframe() {
  const iframeSrc = 'https://mcc-dyc.vercel.app';
  const iframe = document.createElement('iframe');

  iframe.src = iframeSrc;
  iframe.allow = 'fullscreen';
  iframe.style.position = 'fixed';
  iframe.style.top = '0';
  iframe.style.left = '0';
  iframe.style.width = '100%';
  iframe.style.height = '100vh';
  iframe.style.border = 'none';
  iframe.style.zIndex = '9999';
  iframe.style.display = 'none';
  iframe.id = 'mcc-iframe';
  iframe.className = 'mcc-iframe';

  document.body.appendChild(iframe);
  
  console.log('🚗 MCC iframe created');
  
  return iframe;
}

/**
 * Global message listener for MCC app responses
 * Handles color selection and redirect to product pages
 */
(function setupMCCMessageListener() {
  // Prevent duplicate listeners
  if (window.__mccMessageListenerInstalled) {
    console.log('🚗 MCC message listener already installed');
    return;
  }
  
  window.__mccMessageListenerInstalled = true;
  
  window.addEventListener('message', function(event) {
    // Verify message is from MCC app
    if (!event.data || typeof event.data !== 'object') return;
    
    // Handle color selection from MCC app (product-view mode)
    if (event.data.type === 'colorSelected') {
      console.log('🚗 Color selected from MCC:', event.data);
      
      const {
        shopifyProductId,
        shopifyVariantId,
        shopifyProductHandle,
        colorName,
        colorCode,
        brand,
        model,
        year
      } = event.data;
      
      // Build product URL with tracking parameters
      let productUrl;
      
      if (shopifyProductHandle) {
        // Use product handle (preferred)
        productUrl = `/products/${shopifyProductHandle}`;
      } else if (shopifyProductId) {
        // Fallback to product ID
        productUrl = `/products/${shopifyProductId}`;
      } else {
        console.error('🚗 No product ID or handle provided');
        return;
      }
      
      // Add variant if provided
      if (shopifyVariantId) {
        productUrl += `?variant=${shopifyVariantId}`;
      }
      
      // Add UTM tracking parameters
      const utmParams = new URLSearchParams({
        utm_source: 'oemcolors',
        utm_medium: 'landing_page',
        utm_campaign: 'mcc_search',
        utm_content: colorCode || colorName || ''
      });
      
      productUrl += (productUrl.includes('?') ? '&' : '?') + utmParams.toString();
      
      console.log('🚗 Redirecting to product page:', productUrl);
      
      // Track analytics before redirect
      if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
        window.DYCAnalytics.track('custom', {
          category: 'oem_landing',
          action: 'color_selected',
          label: `${colorName || 'Unknown'} (${colorCode || 'N/A'})`,
          metadata: {
            brand: brand,
            model: model,
            year: year,
            shopifyProductId: shopifyProductId,
            shopifyVariantId: shopifyVariantId
          }
        });
      }
      
      // Redirect to product page
      window.location.href = productUrl;
    }
    
    // Handle MCC app close event
    if (event.data.type === 'closeModal') {
      console.log('🚗 Closing MCC iframe');
      const iframe = document.getElementById('mcc-iframe');
      if (iframe) {
        iframe.style.display = 'none';
      }
    }
  });
  
  console.log('🚗 MCC message listener installed successfully');
})();
